import React from 'react';
import { Outlet } from 'react-router-dom';

// Styles
import './main-layout.scss';

// Components
import { LayoutHeader } from './components/layout-header/layout-header';
import { Footer } from '../footer/footer';
import {
  ConnectStripeNotification
} from '../../shared/components/connect-stripe-notification/connect-stripe-notification';
import { BalanceNotification } from '../../shared/components/balance-notification/balance-notification';

type TMainLayoutProps = {};

export const MainLayout = ({}: TMainLayoutProps) => {

  const isAuth = !!localStorage.getItem('token');

  return (
    <div className="main-layout">
      <div className="main-layout--header">
        <LayoutHeader/>
      </div>
      <div className="main-layout--global-message">
        <BalanceNotification/>
        <ConnectStripeNotification/>
      </div>
      <div className="main-layout--content">
        <Outlet/>
      </div>
      {!isAuth && <div className="main-layout--footer">
        <Footer/>
      </div>}
    </div>
  );
}
